commusoftCommon.filter('dateTimeLine', function(CS_LANGUAGE) {
    return function(dateString) {
        moment.locale(CS_LANGUAGE);
        if(moment().isSame(dateString, 'day')){
            return 'Today';
        }else{
            return moment(dateString).format('ddd Do MMMM YYYY')
        }
    };
});